import {Topbar} from "./Topbar.js"
import React from 'react';
import 'split-pane-react/esm/themes/default.css';
import '../css/splitPaneDivider.css';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import {getUsername, updateEmailCookie } from "./Cookies.js";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { updateEmail, updatePasswd } from "./Network.js";
import Alert from '@mui/material/Alert';
import { getSentence } from "./translations.js";





export class Userprofile extends React.Component
{

  constructor()
  {
    super();

    this.createMailForm = this.createMailForm.bind(this)
    this.createPasswdForm = this.createPasswdForm.bind(this)

    this.state = {
        mailForm: "",
        passwdForm: "",
        mailFormDisabled: true,
        passwdFormDisabled: true,
        errorMsg: "",
        passwdHelperText: "",
        passwdError: false,
        oldpasswdHelperText: "",
        oldPasswdError: false
    }
  }

  async componentDidMount() 
  {
    this.createMailForm()
    this.createPasswdForm()
  }


  createMailForm()
  {
    //Create the form to update the user's mail.
    //todo : the user should enter it's password to verify that it is indeed him that do the modification.
    var button = ""

    if (this.state.mailFormDisabled)
    {
        button = <Button
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={async ()=>{await this.setState({mailFormDisabled: false}); this.createMailForm()}}
            >
            {getSentence(29)}
        </Button>
    }
    else
    {
        button = <Button
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={async ()=>{
                await this.setState({mailFormDisabled: true});
                this.createMailForm()
                updateEmail(document.getElementById('mail').value)
                updateEmailCookie(document.getElementById('mail').value)

                //todo : should check the return value (response) from the server before printing the MessageChannel.
                const errormsg = <Alert severity="success"> {getSentence(26) + " " +getUsername()} </Alert>
                this.setState({errorMsg: errormsg})
            }}
            >
            {getSentence(35)}
        </Button>
    }


    this.setState({mailForm: <Stack direction="row" spacing={2}>      
            <TextField
                margin="normal"
                disabled={this.state.mailFormDisabled}
                fullWidth
                id="mail"
                label={getSentence(27)}
                name="email"
                autoComplete="email"
                autoFocus
                defaultValue={getUsername()}
            />
            {button}
        </Stack>})
  }


    passwdTextfield(label)
    {
        return <TextField
            margin="normal"
            disabled={this.state.passwdFormDisabled}
            fullWidth
            name="password"
            label={label}
            type="password"
            id={label}
            error = {this.state.passwdError}
            helperText={this.state.passwdHelperText}
        />
    }

  createPasswdForm()
  {
    //Create the form to update the user's password.
    var button = ""

    if (this.state.passwdFormDisabled)
    {
        button = <Button
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={async ()=>{await this.setState({passwdFormDisabled: false}); this.createPasswdForm()}}
            >
            {getSentence(29)}
        </Button>

        this.setState({passwdForm: <Stack direction="row" spacing={2}>      
            {this.passwdTextfield(getSentence(28))}
            {button}
        </Stack>})
    }
    else
    {
        button = <Button
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={async ()=>{
                const oldpasswd = document.getElementById('Old password').value

                if (document.getElementById(getSentence(33)).value === document.getElementById(getSentence(34)).value)
                {
                    const response = await updatePasswd(oldpasswd, document.getElementById(getSentence(33)).value)

                    if (response == "password error")   // we need to print a message about the old password being erroned.
                    {
                        await this.setState({passwdError: false});
                        await this.setState({passwdHelperText: ""});
                        await this.setState({oldPasswdError: true});
                        await this.setState({oldPasswdHelperText: getSentence(31)});
                        this.createPasswdForm();
                    }
                    else
                    {
                        //we update the password
                        await this.setState({passwdFormDisabled: true});
                        await this.setState({passwdError: false});
                        await this.setState({passwdHelperText: ""});
                        await this.setState({oldPasswdError: false});
                        await this.setState({oldPasswdHelperText: ""});
                        await this.setState({passwdError: false});
                        await this.setState({passwdHelperText: ""});
    
                        this.createPasswdForm();
                    
                        const errormsg = <Alert severity="success">"your password has been successfully changed." </Alert>
                        this.setState({errorMsg: errormsg})
                    }
                }
                else    //We need to print a message saying that both password aren't the same.
                {
                    await this.setState({passwdError: true});
                    await this.setState({passwdHelperText: getSentence(30)});
                    await this.setState({oldPasswdError: false});
                    await this.setState({oldPasswdHelperText: ""});    
                    this.createPasswdForm();
                }
            
            }}
        >
            {getSentence(36)}
        </Button>


        this.setState({passwdForm: <Stack direction="column" spacing={2}>      
            <TextField
                margin="normal"
                disabled={this.state.passwdFormDisabled}
                fullWidth
                name="password"
                label={getSentence(32)}
                type="password"
                id="Old password"
                error = {this.state.oldPasswdError}
                helperText={this.state.oldPasswdHelperText}
            />
            {this.passwdTextfield(getSentence(33))}
            {this.passwdTextfield(getSentence(34))}
            {button}
        </Stack>})
    }
  }



  render()
  {
    //Return the profile page.
    return(
        <div style={{ height: "100vh", overflow: "hidden" }} >
            <Topbar />

            <Container component="main">
                {this.state.errorMsg}
                <CssBaseline />
                <Box
                sx={{
                    marginTop: 8,
                }}
                >
                <Stack direction="column" spacing={5}>
                        {this.state.mailForm}

                        {this.state.passwdForm}
                    </Stack>

                </Box>
            </Container>

        </div>
  );
    
  }
};
